import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

export const ROLE_ASSIGNMENT_COMMUNITY_MEMBERS_RESOURCE = 'roleAssignmentCommunityMembers';

const roleAssignmentCommunityMembersService = ComposedComponent =>
  reduxFetch([
    {
      resource: ROLE_ASSIGNMENT_COMMUNITY_MEMBERS_RESOURCE,
      method: 'get',
      request: communityId => ({
        url: apiRoutes.getCommunityMembers(communityId),
      }),
    },
  ])(ComposedComponent);

export default roleAssignmentCommunityMembersService;
